import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {Mental} from "../../Mental";
import {MentalGameMode} from "../../server/MentalGameMode";
import {IMentalGameData, IMentalInitData} from "../../server/MentalData";
import {MentalSoundConfig} from "../../MentalSoundConfig";
import {SoundManager} from "../../sound/SoundManager";
import {MentalHelper} from "../../utils/MentalHelper";

export class FreeGameIdlePresentation implements FlowStatePresentation {
    private _flowController: FlowStateController;

    private static changeBackgrounds(): void {
        const data: IMentalInitData | IMentalGameData = Mental.model.data,
            currMode: string = data.mode,
            nextMode: string = data.nextMode;

        if (data.isRestoreState && currMode !== MentalGameMode.NORMAL) {
            Mental.fireFrame.showLockedFireFrames(true);
        }

        Mental.background.onChangeMode(nextMode);
        Mental.scatterAnticipation.onChangeMode(nextMode);
        Mental.reelArea.onChangeMode(nextMode);

        if (Mental.deadFeaturePresentation.isCoolOrSuperFs(currMode)) {
            Mental.deadFeatureStickyMultiplier.showSymbolStickers();

            if (data.isRestoreState) {
                Mental.deadFeatureStickyMultiplier.playStickyAnim(data.stickyDeadSymCounterNextSpin);
            }
        }
    }

    // #138
    private static triggerFSAmbienceSound(): void {
        const nextMode: string = Mental.model.data.nextMode;

        let soundName: string;

        if (nextMode === MentalGameMode.COOL_FREESPIN) {
            soundName = MentalSoundConfig.COOL_FS_AMBIANCE;
        } else if (nextMode === MentalGameMode.SUPER_FREESPIN) {
            soundName = MentalSoundConfig.SUPER_FS_AMBIANCE;
        } else {
            soundName = MentalSoundConfig.STANDARD_FS_AMBIANCE;
        }

        SoundManager.startFSMusic(soundName);
    }

    public start(flowStateController: FlowStateController): void {
        Mental.keypadPlugin.setWin(Mental.model.data.accumulatedRoundWin, true, MentalHelper.isWinBelowStake());
        let gameData: IMentalInitData | IMentalGameData = Mental.model.data,
            isRestore: boolean = gameData.isRestoreState,
            currMode: string = gameData.mode,
            nextMode: string = gameData.nextMode,
            isFSUpgrade: boolean =
                ((currMode === MentalGameMode.STANDARD_FREESPIN && (nextMode === MentalGameMode.COOL_FREESPIN || nextMode === MentalGameMode.SUPER_FREESPIN)) ||
                    (currMode === MentalGameMode.COOL_FREESPIN && nextMode === MentalGameMode.SUPER_FREESPIN));

        this._flowController = flowStateController;

        // #199
        if (Mental.autoPlayPlugin.turnOffAutoplayOnBonus) {
            Mental.autoPlayPlugin.turnOffAutoplayOnBonus();
        }

        for (let i = 0; i < Mental.model.data.stickyFires.length; i++) { // to update FS ways
            Mental.xWaysCounter._stickyFFCounterForFS[i] = Mental.model.data.stickyFires[i].filter((value: boolean) => value).length;
        }

        if (currMode === MentalGameMode.NORMAL || isFSUpgrade) {
            FreeGameIdlePresentation.changeBackgrounds();
            Mental.fsIntro.showIntro(isFSUpgrade, () => {
                this.endPresentation();
            });
        } else if (isRestore) {
            for (let i = 0; i < Mental.model.initData.stickyScatter2.length; i++) {
                Mental.stickyScatter.showStickyScatterOnRestore(i, Mental.model.initData.stickyScatter2[i]);
            }
            FreeGameIdlePresentation.changeBackgrounds();

            // #138
            FreeGameIdlePresentation.triggerFSAmbienceSound();

            this.endPresentation();
        } else {
            this.endPresentation()
        }
    }

    private endPresentation(): void {
        this._flowController.finish();
        Mental.keypadPlugin.setZeroBetSpinCounter(Mental.model.data.freespinsLeft - 1);
        SlotGame.apiPlugin.betHandler.zeroBet();
    }
}
